enum VcgVerticalReferenceEnum {
  BOTTOM_BASE = 1,
  VCG_45_8_6 = 2,
  VCG_50_8_6 = 3,
}

export default VcgVerticalReferenceEnum;
